import { Route, Routes } from "react-router-dom";

import React from "react";
import QuizOverview from "./QuizOverview";
import QuizCreate from "./QuizCreate";
import QuizCreateNew from "./QuizCreateNew";
import QuizCreateFromExisting from "./QuizCreateFromExisting";
import QuizView from "./QuizView";
import DirectQuizSubmissionTokenView from "./DirectQuizSubmissionTokenView";
import QuizOverviewStudents from "./QuizOverviewStudents";
import {
  TeacherQuizResponseView,
  StudentQuizSubmissionView,
} from "./StudentQuizSubmission";

export const PrivateQuizRoutes = ({ teacher = false, student = false }) => {
  if (student) {
    return (
      <Routes>
        <Route path="/" element={<QuizOverviewStudents />} />
        <Route
          path="/view/:quizGroupId"
          element={<StudentQuizSubmissionView />} // TODO change
        />
      </Routes>
    );
  }
  if (teacher) {
    return (
      <Routes>
        <Route path="/" element={<QuizOverview />} />
        <Route path="/create" element={<QuizCreate />} />
        <Route path="/create/new" element={<QuizCreateNew />} />
        <Route
          path="/create/from-existing"
          element={<QuizCreateFromExisting />}
        />{" "}
        <Route path="/view/:quizGroupId" element={<QuizView />} />
        <Route
          path="/submission/view/:quizGroupId/:studentId"
          element={<TeacherQuizResponseView />}
        />
      </Routes>
    );
  }
};

export const PublicQuizRoutes = () => {
  return (
    <Routes>
      <Route
        path="/submission/upload/:id"
        element={<DirectQuizSubmissionTokenView />}
      />
    </Routes>
  );
};
